import API from '../../../../../services/api';

export const AVISOS_API = {
    get: async (startDate, endDate) => {
        return API.get(`/avisos${startDate ? `?startDate=${startDate}` : ''}${startDate && endDate ? `&endDate=${endDate}` : ''}`).then(res => res.data);
    },
    getByIncidenciaId: async (incidenciaId) => {
        return API.get('/avisos/incidencia/' + incidenciaId).then(res => res.data);
    },
    new: async (aviso) => {
        return API.post('/avisos', aviso).then(res => res.data);
    },
    update: async (aviso) => {
        return API.put('/avisos/' + aviso.id, aviso).then(res => res.data);
    },
    markAsRead: async (aviso) => {
        return API.put('/avisos/' + aviso.id + '/leido', {leido: true}).then(res => res.data);
    },
    delete: async (avisoId) => {
        return API.delete('/avisos/' + avisoId).then(res => res.data);
    }
}